"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlActions = void 0;
var ControlActions;
(function (ControlActions) {
    ControlActions["LessonComplete"] = "LessonComplete";
    ControlActions["GuardViolation"] = "GuardViolation";
    ControlActions["InvalidActionInput"] = "InvalidActionInput";
    ControlActions["Error"] = "Error";
    ControlActions["Delay"] = "Delay";
    ControlActions["ActionValid"] = "ActionValid";
    ControlActions["MaxErrorsReached"] = "MaxErrorsReached";
    ControlActions["LessonTimedOut"] = "LessonTimedOut";
})(ControlActions = exports.ControlActions || (exports.ControlActions = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL3R5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksY0FTWDtBQVRELFdBQVksY0FBYztJQUN4QixtREFBaUMsQ0FBQTtJQUNqQyxtREFBaUMsQ0FBQTtJQUNqQywyREFBeUMsQ0FBQTtJQUN6QyxpQ0FBZSxDQUFBO0lBQ2YsaUNBQWUsQ0FBQTtJQUNmLDZDQUEyQixDQUFBO0lBQzNCLHVEQUFxQyxDQUFBO0lBQ3JDLG1EQUFpQyxDQUFBO0FBQ25DLENBQUMsRUFUVyxjQUFjLEdBQWQsc0JBQWMsS0FBZCxzQkFBYyxRQVN6QiJ9